import {
  type ProfileTemplateFieldMode,
  type ProfileTemplatePublishStatus,
} from '@up2stay/up2promo-api-client';

import type { TemplateMemberValueColumn } from '@/core/lib/profile-template-member-values';
import type { MemberRosterRow } from '@/core/lib/profile-template-member-values-csv';

import { TemplateFieldPolicySelect } from './template-field-policy-select';
import type { TemplateMemberValuesDict } from './template-member-value-inputs';
import { TemplateMemberValuesTablePopover } from './template-member-values-table-popover';

export type TemplateMemberValuesEditorUiProps = {
  workspaceId?: string;
  templateId?: string;
  publishStatus?: ProfileTemplatePublishStatus;
  memberRoster?: MemberRosterRow[];
  memberRosterLoading?: boolean;
  hasAssignedTeams?: boolean;
  memberValuesDict?: TemplateMemberValuesDict;
  canManage?: boolean;
};

interface TemplatePolicyMemberControlsProps extends TemplateMemberValuesEditorUiProps {
  value: ProfileTemplateFieldMode | undefined;
  onChange: (mode: ProfileTemplateFieldMode) => void;
  labels: { locked: string; free: string };
  disabled?: boolean;
  memberValueColumn?: TemplateMemberValueColumn;
  memberDialogTitle?: string;
  memberDefaultValue?: string;
  memberInputMaxLength?: number;
  memberInputPlaceholder?: string;
  className?: string;
}

export function TemplatePolicyMemberControls({
  value,
  onChange,
  labels,
  disabled = false,
  memberValueColumn,
  memberDialogTitle,
  memberDefaultValue = '',
  workspaceId,
  templateId,
  publishStatus,
  memberRoster = [],
  memberRosterLoading = false,
  hasAssignedTeams = false,
  memberValuesDict,
  canManage = true,
  memberInputMaxLength,
  memberInputPlaceholder,
  className,
}: TemplatePolicyMemberControlsProps) {
  const showMemberEdit =
    hasAssignedTeams &&
    memberValueColumn != null &&
    workspaceId != null &&
    templateId != null &&
    publishStatus != null &&
    memberValuesDict != null;

  return (
    <div
      className={`flex h-10 items-center gap-2 shrink-0 max-sm:h-auto ${className ?? ''}`}
    >
      <TemplateFieldPolicySelect
        value={value}
        onChange={onChange}
        labels={labels}
        disabled={disabled || !canManage}
        className="w-[11rem] max-w-full min-w-0 shrink"
      />
      {showMemberEdit ? (
        <TemplateMemberValuesTablePopover
          column={memberValueColumn}
          title={memberDialogTitle ?? memberValueColumn.label}
          workspaceId={workspaceId}
          templateId={templateId}
          publishStatus={publishStatus}
          roster={memberRoster}
          rosterLoading={memberRosterLoading}
          hasTeams={hasAssignedTeams}
          canManage={canManage}
          dict={memberValuesDict}
          defaultValue={memberDefaultValue}
          maxLength={memberInputMaxLength}
          placeholder={memberInputPlaceholder}
          disabled={disabled}
        />
      ) : null}
    </div>
  );
}
